import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from "./resources";

// Initialize i18next
i18n.use(initReactI18next).init({
  resources,
  lng: navigator.language.split("-")[0] || "en", // Detect browser language
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
